import { GET_CHAT_LIVE} from '../actionTypes';

export default function(state = {}, action) {
    switch (action.type) {
        case GET_CHAT_LIVE:
            return action.payload;
        default:
            return state;
    }
}